// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Internal Dependencies
import connectComponent from '../connect-component';
import CoderList from './CoderList';
import styles from '../styles/Styles';
import { fetchCoders } from '../state/actions/coders-actions';
import { fetchBadges } from '../state/actions/badge-actions';

// Local variables
const thisStyle = styles.codersPage;

// Component definition
class CoderPage extends Component {
  static propTypes = {
    onFetchBadges: PropTypes.func.isRequired,
    onFetchCoders: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.onFetchBadges();
    this.props.onFetchCoders();
  }

  render() {
    return (
      <div>
        <section style={thisStyle.mainSection}>
          <CoderList />
        </section>
      </div>
    );
  }
}

export default connectComponent(() => ({}), {
  onFetchBadges: fetchBadges,
  onFetchCoders: fetchCoders,
}, CoderPage);



/** WEBPACK FOOTER **
 ** ./src/ninjas/CodersPage.js
 **/